
const InputWithIcon = ({
  name,
  icon,
  type,
  placeholder,
  value,
  onChange,
  min,
}) => {
  return (
    <div className="flex password-field items-center">
      <input
        className="body-N"
        name={name}
        value={value}
        min={min ?? 0}
        onChange={onChange}
        type={type}
        step={icon ? "0.01" : "1"}
        placeholder={placeholder}
        onWheel={(e) => {
          if (type === "number") {
            e.target.blur();
          }
        }}
      />

      {/* ✅ render icon ONLY when it exists */}
      {icon && (
        <img
          role="button"
          src={icon}
          alt=""
          className="sidebar-icons"
        />
      )}
    </div>
  );
};

export default InputWithIcon;
